export default function () {
  return {
    checksumError: undefined
  }
}
